"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
export default function Legalbasis() {
  const headlineWords = [{
    text: "La",
    italic: false
  }, {
    text: "espera",
    italic: false
  }, {
    text: "es",
    italic: false
  }, {
    text: "parte",
    italic: false
  }, {
    text: "del",
    italic: false,
    breakBefore: true
  }, {
    text: "pasado",
    italic: false
  }, {
    text: "—",
    italic: false
  }, {
    text: "el",
    italic: false,
    breakBefore: true
  }, {
    text: "futuro",
    italic: false
  }, {
    text: "es",
    italic: false
  }, {
    text: "llegar",
    italic: false,
    breakBefore: true
  }, {
    text: "a",
    italic: false
  }, {
    text: "tiempo.",
    italic: true
  }];
  const {
    ref: markerRef,
    isVisible: markerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: image1Ref,
    isVisible: image1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: image2Ref,
    isVisible: image2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return;
}
function Separator({
  className = ""
}: {
  className?: string;
}) {
  return <span className={`block h-24 w-px bg-foreground/30 ${className}`} aria-hidden="true" />;
}